/**
 * Contains logic to determine whether cta was clicked. This is not the optimal
 * way to do it - a better way would be to include CTA location as part of the
 * creative's concept rendering configuration and to set it explicitly.
 */

import { CLICK_AREA_TYPE_CTA, CLICK_AREA_TYPE_OTHER } from "../constants";

const pointInEl = (el, x, y) => {
  const {
    top: elTop,
    right: elRight,
    bottom: elBottom,
    left: elLeft,
  } = el.getBoundingClientRect();
  return x >= elLeft && x <= elRight && y >= elTop && y <= elBottom;
};

/**
 * Returns true iff (x, y) is within the bounds of a CTA. We
 * consider an element to be a "CTA element" if it's part of the generic-cta or
 * custom-cta components or is in a container that has 'cta' in the id. This can
 * give both false positives (e.g. if a non-CTA image is placed in a CTA
 * container) and false negatives (e.g. if a CTA is embedded in a larger image
 * in one of the "fill" templates), but it's probably close to the best we can
 * do without manual tagging. We include all descendants of cta
 * containers/components, because sometimes their children overflow.
 */
export const pointInCTA = (x, y) => {
  return [
    ...document.querySelectorAll(
      [
        ".generic-cta",
        ".generic-cta *",
        ".custom-cta",
        ".custom-cta *",
        ".cta-container",
        ".cta-container *",
        ".liftoff-cta",
        ".liftoff-cta *",
        ".product-view-cta .light",
        ".last-chance-endscreen-container",
      ].join(", ")
    ),
  ].some((ctaEl) => {
    return pointInEl(ctaEl, x, y);
  });
};

/**
 * Returns true iff e is a MouseEvent that occurred over a CTA.
 */
export const clickAreaTypeFromEvent = (e) => {
  return pointInCTA(e.clientX, e.clientY)
    ? CLICK_AREA_TYPE_CTA
    : CLICK_AREA_TYPE_OTHER;
};

export const isDeadzoneCoord = ({ x, y }) => {
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    console.warn("Unexpected coords", { x, y });
    return;
  }
  return [...document.body.querySelectorAll(".liftoff-deadzone")].some((el) =>
    pointInEl(el, x, y)
  );
};



// WEBPACK FOOTER //
// ./src/js/madlib/cta.js